import * as firestoreService    from  '../../../../common/firestore.service';
import { getUser } from '../../../login/login.service';
import { getBalance } from '../customers/Transactions/transaction.service';
import { Invoice, Item } from './invoice.model';

export function getAllItems(next: any) {
    const userEmail = getUser().email;
    firestoreService.fetchSubCollection('Users', userEmail, 'Items', Item, next);
}

export function getAllInvoices(next: any) {
    const userEmail = getUser().email;
    firestoreService.fetchSubCollection('Users', userEmail, 'Invoices', Invoice, next);
}

// export function getAllInvoicesOfACustomer(id: string, month: number, year: number): Promise<Invoice[]> {
//     const userEmail = getUser().email;
//     const startDate = new Date(`${year}-${month + 1}`);
//     const endDate = new Date(`${month !== 11 ? year: year + 1}-${month !== 11 ? month + 2 : 1}`);
//     console.log(startDate);
//     console.log(endDate);
//     return firestoreService.querySubCollectionWithLimitAndWithMonth('Users', userEmail, 'Invoices', 'customer.id', id, 'date', startDate, 'date', endDate, 'date', 'asc', Invoice);
// }

export function getAllInvoicesOfACustomer(id: string, month: number, year: number, next: any) {
    const userEmail = getUser().email;
    console.log(month,year)
    const startDate = new Date(`${month!==12?`${month<3?year:year-1}-${month + 1}`:`${year-1}-4`}`);
    const endDate = new Date(`${month <2 && month !== 12 ? year-1: year }-${month !== 11 ?( month !== 12 ? month + 2: 3 ): 1}`);
    console.log(startDate);
    console.log(endDate);
    firestoreService.querySubCollectionWithLimitAndWithMonth('Users', userEmail, 'Invoices', 'customer.id', id, 'date', startDate, 'date', endDate, 'date', 'asc', Invoice, next);
}

export function addInvoice(invoice: Invoice): Promise<any> {
    const userEmail = getUser().email;
    const id = firestoreService.getRandomIDInCollection(`Users/${userEmail}/Invoices`);
    invoice.id = id;
    return firestoreService.addSubDocument('Users', userEmail, 'Invoices', id, invoice.toJson());
}

export function getInvoice(id: string, next: any) {
    const userEmail = getUser().email;
    firestoreService.fetchSubDocument('Users', userEmail, 'Invoices', id, Invoice, next);
}

// export function editInvoice(id: string, invoice: Invoice): Promise<any> {
//     const userEmail = getUser().email;
//     return firestoreService.updateSubDocument('Users', userEmail, 'Invoices', id, invoice.toJson());
// }

export function editInvoice(oldInvoiceId: string, newInvoice: Invoice, listener: (status: number) => void) {
    enum Status {
        PROCESS_INITIATED,
        BALANCEDOC_RECEIVED,
        BALANCEDOC_CHANGED,
        OLD_DELETED,
        NEW_SAVED,
        PROCESS_COMPLETED,
        PROCESS_ERR
    };

    console.log(oldInvoiceId);
    console.log(newInvoice);
    let status = Status.PROCESS_INITIATED;
    listener(status);
    // const balanceDoc = `2-2025-${newInvoice.customer.id}`;
    getBalance(2025, 2, newInvoice.customer.id, (values: any) => {
        // console.log('INSIDE GETBALANCE')
        // console.log('RIGHT UNDER: ', status);
        if(status === Status.BALANCEDOC_RECEIVED) {
            status = Status.BALANCEDOC_CHANGED;
        } else if(status === Status.PROCESS_INITIATED) {
            status = Status.BALANCEDOC_RECEIVED;
        }
        listener(status);
        
        console.log(values);
        if(status === Status.BALANCEDOC_RECEIVED) {
            // console.log('DELETEING INVOICE')
            deleteInvoice(oldInvoiceId).then(() => {
                status = Status.OLD_DELETED
                // console.log('INVOICE DELETED')
                listener(status);
            }).catch(() => {
                status = Status.PROCESS_ERR
                listener(status);
            });
        } else if(status === Status.OLD_DELETED) {
            // console.log('ADDING NEW INVOICE')
            addInvoice(newInvoice).then(() => {
                status = Status.NEW_SAVED
                listener(status);
                status = Status.PROCESS_COMPLETED
                listener(status);
                // console.log('INVOICE ADDED')
            }).catch(() => {
                status = Status.PROCESS_ERR
                listener(status);
            });
        }

        if(status === Status.NEW_SAVED) {
            status = Status.PROCESS_COMPLETED;
        }

    });
}

export function deleteInvoice(id: string): Promise<any> {
    const userEmail = getUser().email;
    return firestoreService.deleteSubDocument('Users', userEmail, 'Invoices', id);
}
// export function getAllCustomerRef(): Promise<CustomerRef[]> {
//     return firestoreService.fetchSubCollection('Users', userEmail, 'Customers', CustomerRef);
// }

// export function getCustomer(id: string): Promise<Customer> {
//     return firestoreService.fetchSubDocument('Users', userEmail, 'Customers', id, Customer);
// }

// export function addCustomer(customer: Customer): Promise<any> {
//     const id = firestoreService.getRandomIDInCollection(`${userEmail}/${userEmail}/Customer`);
//     customer.id = id;
//     return firestoreService.addSubDocument('Users', userEmail, 'Customers', id, customer.toJson());
// }
